<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">玩法配置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="游戏管理" name="game">
                 <!-- 搜索筛选 -->
                <el-form :inline="true" :model="formInline" label-width="30px" class="user-search">
                    <el-form-item label=" ">
                        <el-button size="small" type="primary" @click="addGameClick">新增游戏</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" max-height="600px" :data="listData" highlight-current-row border style="width:1600px">
                    <el-table-column  prop="gameName" label="游戏昵称" align="center" ></el-table-column>
                    <el-table-column  prop="id" label="游戏id" align="center" ></el-table-column>
                    <el-table-column  prop="orderNum" label="排序" align="center" ></el-table-column>
                    <el-table-column align="center" label="操作" >
                        <template slot-scope="scope">
                        <el-button type="text" v-preventReClick @click="delClick(scope.row)">删除</el-button>
                        <el-button type="text" v-preventReClick @click="editpPlaying(scope.row)">编辑玩法</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>       
            <el-tab-pane label="明细管理" name="gamedetails">
                 <!-- 搜索筛选 -->
                 <el-form :inline="true" :model="formInline" label-width="30px" class="user-search">
                    <el-form-item label=" ">
                        <el-button size="small" type="primary" @click="addSactionClick">新增</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" max-height="600px" :data="SactionList" highlight-current-row border style="width:1600px">
                <el-table-column  prop="name" label="明细昵称" align="center" ></el-table-column>
                <el-table-column  prop="id" label="id" align="center" ></el-table-column>
                <el-table-column  prop="moreId" label="moreId" align="center" ></el-table-column>
                <el-table-column  prop="orderNum" label="排序" align="center" ></el-table-column>
                <el-table-column align="center" label="操作" >
                    <template slot-scope="scope">
                    <el-button type="text" v-preventReClick @click="SactionDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
       
        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->

        <!-- 编辑游戏玩法 -->
        <el-dialog :visible.sync="editGameFlag" width="40%" >
            <el-button size="small" type="primary" @click="addActionClick">新增玩法</el-button>
            <el-table size="small" max-height="600px" :data="actionData" highlight-current-row border style="width:1600px">
                <el-table-column  prop="name" label="玩法名称" align="center" ></el-table-column>
                <el-table-column  prop="kindId" label="kindId" align="center" ></el-table-column>
                <el-table-column  prop="moreId" label="moreId" align="center" ></el-table-column>
                <el-table-column align="center" label="操作" >
                    <template slot-scope="scope">
                    <el-button type="text" v-preventReClick @click="actionDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editGameFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="addGameSubmit('addGameForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 新增游戏 -->
        <el-dialog :visible.sync="addGameFlag" width="30%" >
            <el-form label-width="120px" :model="addGameForm" :rules="rules" ref="addGameForm">
                <el-form-item label="游戏名称" prop="gameName">
                    <el-input el-input size="small" v-model="addGameForm.gameName" auto-complete="off" placeholder="请输入游戏名称"></el-input>
                </el-form-item>
                <el-form-item label="游戏id" prop="id">
                    <el-input el-input size="small" v-model="addGameForm.id" auto-complete="off" placeholder="请输入游戏id"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="orderNum">
                    <el-input el-input size="small" v-model="addGameForm.orderNum" auto-complete="off" placeholder="请输入排序"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addGameFlag = false">关闭</el-button>
                <!-- <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="addGameSubmit('addGameForm')">保存</el-button> -->
            </div>
        </el-dialog>

        <!-- 新增玩法 -->
        <el-dialog :visible.sync="addActionFlag" width="30%" >
            <el-form label-width="120px" :model="addActionForm" :rules="rules" ref="addActionForm">
                <el-form-item label="玩法名称" prop="name">
                    <el-input el-input size="small" v-model="addActionForm.name" auto-complete="off" placeholder="请输入玩法名称"></el-input>
                </el-form-item>
                <el-form-item label="玩法id" prop="id">
                    <el-input el-input size="small" v-model="addActionForm.id" auto-complete="off" placeholder="请输入玩法id"></el-input>
                </el-form-item>
                <el-form-item label="kindId" prop="kindId">
                    <el-input el-input size="small" v-model="addActionForm.kindId" auto-complete="off" placeholder="请输入kindId"></el-input>
                </el-form-item>
                <el-form-item label="moreId" prop="moreId">
                    <el-input el-input size="small" v-model="addActionForm.moreId" auto-complete="off" placeholder="请输入moreId"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addActionFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="addActionSubmit('addActionForm')">保存</el-button>
            </div>
        </el-dialog>


        <!-- 新增明细 -->
        <el-dialog :visible.sync="addSactionFlag" width="30%" >
            <el-form label-width="120px" :model="addSactionForm" :rules="rules" ref="addSactionForm">
                <el-form-item label="明细名称" prop="name">
                    <el-input el-input size="small" v-model="addSactionForm.name" auto-complete="off" placeholder="请输入玩法名称"></el-input>
                </el-form-item>
                <el-form-item label="明细id" prop="id">
                    <el-input el-input size="small" v-model="addSactionForm.id" auto-complete="off" placeholder="id"></el-input>
                </el-form-item>
                <el-form-item label="moreId" prop="moreId">
                    <el-input el-input size="small" v-model="addSactionForm.moreId" auto-complete="off" placeholder="请输入moreId"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="orderNum">
                    <el-input el-input size="small" v-model="addSactionForm.orderNum" auto-complete="off" placeholder="请输入排序"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addSactionFlag = false">取消</el-button>
                <el-button size="small" type="primary" v-preventReClick :loading="loading" class="title" @click="addSactionSubmit('addSactionForm')">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>
    
<script>
import Pagination from '../../../components/Pagination'
import { barbranchGamelist , barbranchGameAdd  , barbranchGameDel ,
    barbranchGameActionList , barbranchGameActionAdd , barbranchGameActionDel,
    barbranchGamesactionList  , barbranchGameSactionAdd , barbranchGameSactionDel
} from '../../../api/userMG'
export default {
    data () {
        return {
            addSactionForm:{},
            addSactionFlag:false,
            SactionList:[],
            addActionForm:{},
            addActionFlag:false,
            actionData:[],
            editGameFlag:false,
            addGameFlag:false,
            addGameForm:{},
            activeName:'game',
            loading:false,
            listData:[],
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                kindId: [
                    { required: true, message: '请输入kindId', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                moreId: [
                    { required: true, message: '请输入moreId', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
                gameName: [
                    { required: true, message: '请输入游戏名称', trigger: 'blur' },
                ],
                id: [
                    { required: true, message: '请输入id  ', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/  }
                ],
                orderNum: [
                    { required: true, message: '请输入排序', trigger: 'blur' },
                    { message: '格式错误', trigger: 'blur' , pattern:/^[0-9]*$/ }
                ],
            },
            gameId:'',
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata(),
        this.getSactionList()
        
    },
    methods: {
        SactionDel(row){
            this.$confirm('确定要删除明细吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                barbranchGameSactionDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getSactionList()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addSactionSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    barbranchGameSactionAdd(this.addSactionForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.messages)
                        }else {
                            this.$message.success("操作成功")
                            this.getSactionList()
                            this.addSactionFlag = false
                        }
                    })
                } else {
                    return false
                }
            })
        },
        addSactionClick(){
            this.addSactionFlag = true
            this.addSactionForm = {
                name:'',
                moreId:'',
                orderNum:''
            }
        },
        getSactionList(){
            barbranchGamesactionList().then(res=>{
                this.SactionList = res.data
            })
        },
        actionDel(row){
            this.$confirm('确定要删除玩法吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                barbranchGameActionDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.editpPlaying({id:this.gameId})
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        addActionSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    barbranchGameActionAdd(this.addActionForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.messages)
                        }else {
                            this.$message.success("操作成功")
                            this.editpPlaying({id:this.gameId})
                            this.addActionFlag = false
                        }
                    })
                } else {
                    return false
                }
            })
        },
        addActionClick(){
            this.addActionFlag = true
            this.addActionForm = {
                "gameid": this.gameId,
                "id": "",
                "kindId": "",
                "moreId": "",
                "name": ""
            }
        },
        editpPlaying(row){
            barbranchGameActionList(row.id).then(res=>{
                this.editGameFlag = true
                this.actionData = res.data
                this.gameId = row.id
            })
        },
        addGameSubmit(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    barbranchGameAdd(this.addGameForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.messages)
                        }else {
                            this.$message.success("操作成功")
                            this.getdata()
                            this.addGameFlag = false
                        }
                    })
                } else {
                    return false
                }
            })
        },
        delClick(row){
            this.$confirm('确定要删除游戏吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                barbranchGameDel(row.id).then(res=>{
                    if(res.success){
                        this.$message.success("操作成功")
                        this.getdata()
                    }else{
                        this.$message.error(res.messages)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },  
        addGameClick(){
            this.addGameFlag = true
            this.addGameForm = {
                gameName:'',
                orderNum:'',
                id:''
            }
        },  
        submitForm(form){
            this.$refs[form].validate(valid => {
                if (valid) {
                    let data = JSON.parse(JSON.stringify(this.editForm))
                    data.amount = data.amount*100
                    data.integral = Number(data.integral)
                    integralSettingSave(data).then(res=>{
                        if(!res.success){
                            this.$message.error(res.messages)
                        }else {
                            this.$message.success(this.editForm.id == ''?'创建成功':'修改成功')
                            this.getdata()
                            this.editFormVisible = false
                            this.editForm = {
                                amount:'',
                                integral:'',
                                id:''
                            }
                        }
                    })
                } else {
                    return false
                }
            })
        },  

        
        handleEdit(row){
            this.editForm = {
                amount:row.amount/100,
                integral:row.integral,
                ordernum:row.ordernum,
                id:row.id
            }
            this.editFormVisible = true
        },
        closeDialog(){
            this.$refs.editForm.clearValidate();
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        getdata(){
            barbranchGamelist().then(res=>{
                this.listData = res.data
            })
        },
    },
    computed: {
		editor() {
			return this.$refs.myQuillEditor.quill
		}
    },
    mounted() {
    // console.log('this is current quill instance object', this.editor)
    },
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/SiteManagement/gamebarManage/gameUbiManage.vue